import { createContext, useContext, type ReactNode } from 'react';

export type StoryLayoutHeroContextValue = {
  hero: ReactNode;
  setHero: (node: ReactNode | null) => void;
};

export const StoryLayoutHeroContext = createContext<StoryLayoutHeroContextValue | null>(
  null
);

export function useStoryLayoutHero(): StoryLayoutHeroContextValue {
  const v = useContext(StoryLayoutHeroContext);
  if (!v) {
    throw new Error('useStoryLayoutHero must be used within StoryLayout');
  }
  return v;
}
